export const formatPermissions = (rights = []) => {
    const map = {};
  
    rights.forEach((item) => {
      const moduleName = item.subMenu;
  
      if (!map[moduleName]) {
        map[moduleName] = {};
      }
  
      item.permissions?.forEach((perm) => {
        map[moduleName][perm.key.toLowerCase()] = perm.allowed;
      });
    });
  
    return map;
  };